import React from "react";
import { Container, Form } from "react-bootstrap";
import { Label } from "reactstrap";
import "../components/style/SpSelectCriteriaFilterationBar.scss";

function SpSelectCriteriaFilterationBar(props) {
	//Supervisor Select Criteria FilterationBar
	return (
		<Container fluid className="p-0 mt-4">
			<Form>
				<Label className="select-criteria-form-title">
					Select Criteria
				</Label>
				{props.children}
			</Form>
		</Container>
	);
}

export default SpSelectCriteriaFilterationBar;
